(function(angular) {
    angular.module('bizPartEngage').directive('bizModuleBlogList', bizModuleBlogListDirective);

    bizModuleBlogListDirective.$inject = [];

    function bizModuleBlogListDirective() {
        var directive = {
            restrict: "E",
            scope: {
                settings: "="
            },
            templateUrl: function(element, attr) {
                if (attr.templateurl) {
                    return siteRootPath + attr.templateurl;
                } else {
                    return siteRootPath + "FrontEnd/Modules/Blog/Views/blog-list.html"
                }
            },
            controller: bizModuleBlogListController,
            controllerAs: "vm",
            bindToController: true
        };

        bizModuleBlogListController.$inject = ["$rootScope", "modules.blog.service", "$timeout", "$sce", "core.services.favorite"];

        function bizModuleBlogListController($rootScope, blogService, $timeout, $sce, favoritesService) {
            var vm = this;
            vm.BlogItems = [];

            vm.Init = Init;

            function InitObjectMiniList() {

                console.log("bloglist settings", vm.settings);
                vm.BlogItemsForMiniObjectList = [];

                for (var i = 0; i < vm.BlogItems.length; i++) {
                    var blogItem = vm.BlogItems[i];

                    var miniObject = {
                        Id: blogItem.Id,
                        Name: blogItem.Title,
                        Description: blogItem.Description,
                        ImageUrl: blogItem.ImageUrl,
                        EngageObjects: [],
                        Url: { state: 'base.modules.blogtitle', params: { title: blogItem.UrlRewrite } }
                    };

                    if ($rootScope.showFirstTagForTypes && $rootScope.showFirstTagForTypes.indexOf('BLOG') >= 0) {
                        if (blogItem && blogItem.Tags && blogItem.Tags.length > 0 && blogItem.Tags[0].Name.length > 0) {
                            miniObject.OverrideTypeLabel = blogItem.Tags[0].Name;
                        }
                    }

                    vm.BlogItemsForMiniObjectList.push(miniObject);
                }
            }

            function Init() {
                var ids = [];

                if(!vm.settings) {
                    console.warn('No settings provided...');
                    return;
                }
                
                if(!vm.settings.Filter && vm.settings.SelectedFilter) vm.settings.Filter = vm.settings.SelectedFilter.Value;
                if(!vm.settings.Limit && vm.settings.SelectedLimit) vm.settings.Limit = vm.settings.SelectedLimit.Value;

				function ParseIds(value) {
					if (Array.isArray(value)) return value;
					if (value === undefined || value === null || value === '') return null;

					try {
						return JSON.parse(value) || null;
					} catch (e) {
						console.warn('Unable to parse blog list IDs', value);
						return null;
					}
				}

                if (vm.settings.Filter == 'newest') {
                    const categoryIds = ParseIds(vm.settings.CategoryIds);
                    const tagIds = ParseIds(vm.settings.TagIds);
                    blogService.GetNewestBlogEntries(0, true, true, tagIds, vm.settings.Limit + 1, categoryIds).then(GetBlogPostsSuccess);
                }
                else if(vm.settings.Filter == 'journey') {
                    blogService.GetBlogEntriesByJourneyOrder(0, true, true, $rootScope.FavoriteTagIds, vm.settings.Limit + 1).then(GetBlogPostsSuccess);
                }
                else if(vm.settings.Filter == 'related') {
                    blogService.GetRelatedBlogPosts(vm.settings.RelatedId).then(GetBlogPostsSuccess);
                }
                else if(vm.settings.Filter == 'mostcommented') {
                    blogService.GetMostCommentedPosts(vm.settings.Limit).then(GetBlogPostsSuccess);
                }
                else if(vm.settings.Filter == 'mostliked') {
                    blogService.GetMostLikedPosts(vm.settings.Limit).then(GetBlogPostsSuccess);
                }
                else if(vm.settings.Filter == 'featured') {

                    for(var i = 0; i < vm.settings.Limit; i++) {
                        ids.push(vm.settings.SelectedBlogs[i].Id);
                    }
                    
                    blogService.GetBlogPosts(ids).then(GetBlogPostsSuccess);
                }

                function GetBlogPostsSuccess(response) {
                    if(vm.settings.Filter == 'featured') {
                        vm.BlogItems = [];

                        for(var i = 0; i < ids.length; i++) {
                            vm.BlogItems.push(response.data.GetItemByValue('Id', ids[i]));
                        }
                    }
                    else {
                        vm.BlogItems = response.data;
                    }

                    HandleItems();
                }

                function HandleItems() {
                    for (var i = 0; i < vm.BlogItems.length; i++) {
                        vm.BlogItems[i].DisplayDates = FormatCreatedUpdatedDateDisplay(vm.BlogItems[i].Created, vm.BlogItems[i].Updated);
                    }

                    InitObjectMiniList();
                }
            }

            vm.$onInit = vm.Init;

            if (angular.version.major === 1 && angular.version.minor < 5) {
                vm.$onInit();
            }
        }

        return directive;
    }
})(window.angular);
